import type { ReactElement } from 'react';

export const PropBypass = <A,>({
	children,
	key,
	...props
}: A & {
	children: (props: A) => ReactElement;
	key: string;
	// @ts-expect-error Argument of type 'Omit<A & { children: (props: A) => ReactElement<any, string | JSXElementConstructor<any>>; key: string; }, "children" | "key">' is not assignable to parameter of type 'A'.
}) => children(props);
